import {useConfirmEmailMutation} from "../query";
import {useFeedbackTools} from "../../../components/FeedbackTools";
import {useTranslation} from "react-i18next";
import Button from "@mui/material/Button";


const ConfirmEmailButton = ({userId, onEmailConfirmed}) => {
    const {t} = useTranslation('user');

    const confirmEmailMutation = useConfirmEmailMutation();
    const {askConfirmation} = useFeedbackTools();

    const handleConfirmEmail = async () => {
        askConfirmation({
            title: t('confirmEmailButton.dialogTitle'),
            description: t('confirmEmailButton.dialogMessage'),
            confirmationText: t('confirmEmailButton.buttonText'),

            onConfirm: async () => {
                await confirmEmailMutation.mutateAsync(userId);
                onEmailConfirmed();
            }
        });
    }

    return <Button onClick={handleConfirmEmail} disabled={confirmEmailMutation.isLoading} variant="text" sx={{ minHeight: 0, minWidth: 0, padding: 0 }}>
        {t('confirmEmailButton.buttonText')}
    </Button>
}


export default ConfirmEmailButton;